import { render, staticRenderFns } from "./PaymentChoice.html?vue&type=template&id=1dd64902&scoped=true&"
import script from "./PaymentChoice.js?vue&type=script&lang=js&"
export * from "./PaymentChoice.js?vue&type=script&lang=js&"
import style0 from "./PaymentChoice.scss?vue&type=style&index=0&id=1dd64902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd64902",
  null
  
)

export default component.exports